var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChat = function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.5 0h-14a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h11.59l3.7 3.71a1 1 0 0 0 .71.29.84.84 0 0 0 .38-.08 1 1 0 0 0 .62-.92V3a3 3 0 0 0-3-3m1 16.59-2.29-2.3a1 1 0 0 0-.71-.29h-12a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1z"
  })));
};
export default SvgChat;